// src/services/socialLoginService.ts
/**
 * Social Login: リダイレクト用の URL を返す関数（プロバイダーが「line」のみ対応）
 * 本来、バックエンド側でリダイレクト（HTTP302）する実装になっているため、
 * ブラウザ側では直接この URL へ遷移させる実装とします。
 *
 * @param provider string ("line"のみ対応)
 */
export const getSocialLoginUrl = (provider: string): string => {
  const apiBaseUrl =
    process.env.REACT_APP_API_URL;
  return `${apiBaseUrl}/users/social/${provider}/`;
};

/**
 * Social Login Callback API
 * GET: /users/social/:provider/callback/
 *
 * @param provider string ("line"のみ対応)
 * @param query GET パラメータのオブジェクト
 */
export const socialLoginCallback = async (
  provider: string,
  query: Record<string, string>
): Promise<Response> => {
  const queryString = new URLSearchParams(query).toString();
  const url = `${process.env.REACT_APP_API_URL}/users/social/${provider}/callback/?${queryString}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Social login callback failed');
  }
  return response;
};
